import { Refresh } from '@browser/Browser';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { ICommandBase } from '@Quest/cqrs';
import { ProjectPlanTemplateData, ProjectPlanTemplateEditorViewModel } from '@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor';
import ProjectPlanTemplateEditor from '@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor.vue';
import { CreateCorporateProjectPlanTemplateCommandV1, DeleteCorporateProjectPlanTemplateCommandV1, UpdateCorporateProjectPlanTemplateCommandV1 } from '@Quest/Strategies/Domain/commands-core';
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import StrategiesQueries from '@Quest/Strategies/Domain/queries-vue-component';
import { ProjectPlanTemplateReadModel, ProjectPlanTemplatesPageReadModel } from '@Quest/Strategies/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({ components: { CorporateNavigation, ProjectPlanTemplateEditor }})
export default class ProjectPlanTemplatesPage extends mixins(StrategiesQueries, StrategiesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: ProjectPlanTemplatesPageReadModel | null = null;

    projectPlanTemplateEditor: ProjectPlanTemplateEditorViewModel = new ProjectPlanTemplateEditorViewModel();

    showProjectPlanTemplateCreator()
    {
        this.projectPlanTemplateEditor.showCreator();
    }

    showProjectPlanTemplateEditor(t: ProjectPlanTemplateReadModel)
    {
        this.projectPlanTemplateEditor.showEditor(t);
    }


    handleCreateCorporateProjectPlanTemplateCommand(p: ProjectPlanTemplateData)
    {
        this.invokeCreateCorporateProjectPlanTemplateCommandV1(this.workspaceId, this.strategyId, p.Id, p.Name,
            p.Description, p.PlanningHorizonInYears, p.DurationInMonths, p.Granularity, p.Denomination);
    }

    handleUpdateCorporateProjectPlanTemplateCommand(p: ProjectPlanTemplateData)
    {
        this.invokeUpdateCorporateProjectPlanTemplateCommandV1(this.workspaceId, this.strategyId, p.Id, p.Name,
            p.Description, p.PlanningHorizonInYears, p.DurationInMonths, p.Granularity, p.Denomination);
    }

    handleDeleteCorporateProjectPlanTemplateCommand(t: ProjectPlanTemplateReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteCorporateProjectPlanTemplateCommandV1(this.workspaceId, this.strategyId, t.Id);
        }
    }

    mounted()
    {
        document.title = "Enterprise business case templates";
        this.runProjectPlanTemplatesPageQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "ProjectPlanTemplatesPageReadModel")
        {
            this.rm = model as ProjectPlanTemplatesPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateCorporateProjectPlanTemplateCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (UpdateCorporateProjectPlanTemplateCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (DeleteCorporateProjectPlanTemplateCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }
}
